module.exports = __webpack_public_path__ + "static/media/Open-sans-tegn.131f0619.png";